module.exports = __webpack_public_path__ + "static/media/brand-nisa.32349529.png";